import Button from '@mui/material/Button';
import { navigate } from 'gatsby';
import React from 'react';

interface BannerProps {
  banner: string;
  link: string;
  display?: boolean;
}

export default function Banner(props: BannerProps) {
  if (props.display) {
    return (
      <Button
        style={{ minWidth: '100%', borderRadius: 0 }}
        onClick={() => {
          navigate(props.link);
        }}
        color='info'
        size='large'
        sx={{ backgroundColor: 'secondary.main' }}
      >
        {props.banner}
      </Button>
    );
  } else {
    return <></>;
  }
}
